export const convertCoordinatesToWallBasedPositioning = (measurements, mirror) => {
    let stoveCooridnates = { x: measurements.stovePosition.x, y: measurements.stovePosition.y };
    if (mirror) stoveCooridnates.x = measurements.doorWallWidth - measurements.stovePosition.x;
    let stovePosition = {};
    if (stoveCooridnates.y <= 326) {
        stovePosition.stoveWall = "back";
        stovePosition.stoveFromLeft = stoveCooridnates.x;
    }
    else if (stoveCooridnates.x <= 326) {
        stovePosition.stoveWall = "left";
        stovePosition.stoveFromLeft = measurements.depth - stoveCooridnates.y;
    }
    else if (stoveCooridnates.y >= measurements.depth - 326) {
        stovePosition.stoveWall = "front";
        stovePosition.stoveFromLeft = measurements.doorWallWidth - stoveCooridnates.x;
    }
    else if (stoveCooridnates.x >= measurements.doorWallWidth - 326) {
        stovePosition.stoveWall = "right";
        stovePosition.stoveFromLeft =stoveCooridnates.y;
    }
    else {
        stovePosition.stoveWall = "center";
    }
    return stovePosition;
}





export const convertWallBasedPositioningToCoordinates = (wall, stoveFromLeft, saunaWidth, saunaDepth) => {
    let result = { x: 0, y: 0 }
    let stoveOffset = 325;
    switch (wall) {
        case "left":
            result.x = stoveOffset;
            result.y = saunaDepth - stoveFromLeft;
            break;
        case "right":
            result.x = saunaWidth - stoveOffset;
            result.y = stoveFromLeft;
            break;
        case "back":
            result.x = stoveFromLeft;
            result.y = stoveOffset;
            break;
        case "front":
            result.x = saunaWidth - stoveFromLeft;
            result.y = saunaDepth - stoveOffset;
            break;               
        default:
            result.x = saunaWidth / 2;
            result.y = saunaDepth / 2;
            break;
    }
    return result;


}
